// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.IconArrowsChevronRight = function IconArrowsChevronRight (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"title","attr":{}},{"tag":"path","attr":{"d":"M3,5.88 L4.90283401,4 L13,12 L4.90283401,20 L3,18.12 L9.18083671,12 L3,5.88 L3,5.88 Z M11,5.88 L12.902834,4 L21,12 L12.902834,20 L11,18.12 L17.1808367,12 L11,5.88 Z"}}]})(props);
};
